import {Link} from 'react-router-dom';
import {Button, Segment} from 'semantic-ui-react';
import ReportsList from './reports-list';
import StudentCourseMenu from '../shared/student_course_menu';
import Fetcher from '../shared/fetches/fetcher';
import {fetchStudentReports} from '../../redux/actions/report';

function ReportsListContainer() {
  return (<StudentCourseMenu render={renderContent}/>);
}

function renderContent(studentCourse) {
  return (
    <Fetcher
      action={fetchStudentReports.bind(null, studentCourse.id)}
      stateSelector={state => state.reports}
      renderEmpty={renderEmpty}
    >
      {reports => <ReportsList reports={reports}/>}
    </Fetcher>
  );
}

function renderEmpty() {
  return (
    <Segment textAlign='center'>
      <p>برای شما تاکنون گزارشی برای این دوره آموزشی ثبت نگردیده است.</p>
      <Button primary as={Link} to='/report' content='ثبت گزارش جدید'/>
    </Segment>
  );
}

export default ReportsListContainer;
